<template>
  <el-dialog :title="title" :visible.sync="open" width="55%" append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-row>
        <!-- <el-col :span="12">
          <el-form-item label="所属项目类别" prop="projectCategory">
            <el-input v-model="form.projectCategory" placeholder="请输入所属项目类别"></el-input>
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-form-item label="设备编号" prop="eqptNum">
            <el-input v-model="form.eqptNum" placeholder="请输入设备编号" :disabled="title !== '添加设备校准信息'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="设备名称" prop="eqptName">
            <el-input v-model="form.eqptName" placeholder="请输入设备名称" :disabled="title !== '添加设备校准信息'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="校验类型" prop="eqptType">
            <el-select v-model="form.eqptType" placeholder="请选择校验类型" clearable style="width: 100%">
              <el-option label="校准" value="校准" />
              <el-option label="检定" value="检定" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="校准方式" prop="eqptWay">
            <el-select v-model="form.eqptWay" placeholder="请选择校准方式" clearable style="width: 100%">
              <el-option label="送检" value="送检" />
              <el-option label="现场" value="现场" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="校准/检定单位" prop="eqptOrg">
            <el-input v-model="form.eqptOrg" placeholder="请输入校准/检定单位"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="检定/校准日期" prop="eqptDate">
            <el-date-picker v-model="form.eqptDate" type="date" placeholder="选择检定/校准日期" style="width: 100%" value-format="yyyy-MM-dd" @change="calculateValidity">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="校准周期(月)" prop="eqptCycle">
            <el-input-number v-model="form.eqptCycle" :min="1" :max="60" placeholder="请输入校准周期" @change="calculateValidity"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="有效期至" prop="eqptValidity">
            <el-date-picker v-model="form.eqptValidity" type="date" placeholder="选择有效期至" style="width: 100%" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="证书编号" prop="certificateNo">
            <el-input v-model="form.certificateNo" placeholder="请输入检定/校准证书编号"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="检定/校准结论" prop="eqptConclusion">
            <el-select v-model="form.eqptConclusion" placeholder="请选择检定/校准结论" filterable allow-create default-first-option style="width: 100%">
              <el-option label="合格" value="合格" />
              <el-option label="不合格" value="不合格" />
              <el-option label="A级" value="A级" />
              <el-option label="B级" value="B级" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="检定证书" prop="eqptCertFile">
            <el-upload class="upload-demo" :action="'#'" :http-request="() => {}" :file-list="certFileList" :on-change="handleCertFileChange" :on-remove="handleCertFileRemove"
                       :on-preview="handleCertFilePreview" :limit="1" :before-upload="beforeUpload">
              <el-button size="small" type="primary">选择文件</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="证书确认表" prop="eqptConfirmFile">
            <el-upload class="upload-demo" :action="'#'" :http-request="() => {}" :file-list="confirmFileList" :on-change="handleConfirmFileChange" :on-remove="handleConfirmFileRemove"
                       :on-preview="handleConfirmFilePreview" :limit="1" :before-upload="beforeUpload">
              <el-button size="small" type="primary">选择文件</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveEqptVerification, updateEqptVerification, queryEqptVerification } from '@/api/contract/contract';
export default {
  name: "AddAndEdit",
  props: {
    eqptNum: {
      type: String,
      default: ""
    },
    eqptName: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 表单参数
      form: {
        id: undefined,
        projectCategory: "",
        eqptNum: "",
        eqptName: "",
        eqptType: "",
        eqptWay: "",
        eqptOrg: "",
        eqptDate: "",
        eqptValidity: "",
        eqptCycle: 0,
        certificateNo: "",
        eqptConclusion: "合格",
        eqptCertFile: "",
        eqptConfirmFile: ""
      },
      oldEqptValidity: '',
      // 表单校验
      rules: {
        projectCategory: [
          { required: true, message: "请输入所属项目类别", trigger: "blur" }
        ],
        eqptType: [
          { required: true, message: "请选择校验类型", trigger: "change" }
        ],
        eqptWay: [
          { required: true, message: "请选择校准方式", trigger: "change" }
        ],
        eqptOrg: [
          { required: true, message: "请输入校准/检定单位", trigger: "blur" }
        ],
        eqptDate: [
          { required: true, message: "请选择检定/校准日期", trigger: "change" }
        ],
        eqptValidity: [
          { required: true, message: "请选择有效期至", trigger: "change" }
        ],
        eqptCycle: [
          { required: true, message: "请输入校准周期", trigger: "blur" }
        ],
        certificateNo: [
          { required: true, message: "请输入证书编号", trigger: "blur" }
        ],
        eqptConclusion: [
          { required: true, message: "请选择检定/校准结论", trigger: "change" }
        ]
      },
      // 文件列表
      certFileList: [],
      confirmFileList: [],
      // 存储所有上传文件
      uploadFiles: []
    };
  },
  created () {
    // 初始化设备编号和名称
    this.form.eqptNum = this.eqptNum;
    this.form.eqptName = this.eqptName;
  },
  methods: {
    // 打开新增对话框
    openDialog (type, row) {
      this.reset();
      if (type === "Add") {
        console.log(row);
        this.title = "添加设备校准信息";
        if (row) {
          this.form.eqptNum = row.eqptNum;
          this.form.eqptName = row.eqptName;
          this.form.eqptType = row.eqptVerificationType;
          this.form.eqptWay = row.eqptVerificationWay;
          this.form.eqptCycle = row.eqptVerificationCycle;
          this.form.projectCategory = row.projectCategory;
        }
      } else {
        this.title = "修改设备校准信息";
        // 先使用行数据填充基础信息
        this.form = Object.assign({}, this.form, row);
        this.oldEqptValidity = row.eqptValidity;

        // 调用API获取详细信息，包括文件列表
        queryEqptVerification(row.calNum).then(res => {
          if (res.retCode === 'ok') {
            // 使用API返回的详细数据更新表单
            this.form = Object.assign({}, this.form, res.additionalData);

            // 处理文件列表
            if (res.additionalData.files && Array.isArray(res.additionalData.files)) {
              this.certFileList = [];
              this.confirmFileList = [];
              res.additionalData.files.forEach(file => {
                if (file.fileName && file.fileName.includes('检定证书')) {
                  this.certFileList.push({
                    name: file.fileName,
                    url: file.filePath,
                    serverFile: true,
                    ...file
                  });
                  this.form.eqptCertFile = file.filePath;
                } else if (file.fileName && file.fileName.includes('证书确认表')) {
                  this.confirmFileList.push({
                    name: file.fileName,
                    url: file.filePath,
                    serverFile: true,
                    ...file
                  });
                  this.form.eqptConfirmFile = file.filePath;
                }
              });
            }
          } else {
            this.$message.error(res.msg || '获取校准详情失败');
          }
        });
      }
      this.open = true;
    },
    // 取消按钮
    cancel () {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset () {
      this.form = {
        id: undefined,
        projectCategory: "",
        eqptNum: this.eqptNum,
        eqptName: this.eqptName,
        eqptType: "",
        eqptWay: "",
        eqptOrg: "",
        eqptDate: "",
        eqptValidity: "",
        eqptCycle: 0,
        certificateNo: "",
        eqptConclusion: "合格",
        eqptCertFile: "",
        eqptConfirmFile: ""
      };
      this.certFileList = [];
      this.confirmFileList = [];
      this.uploadFiles = [];
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    // 上传前校验
    beforeUpload (file) {
      // 支持的文件类型
      const allowedTypes = [
        // 图片格式
        'image/jpeg',
        'image/png',
        // PDF格式
        'application/pdf',
        // Word格式
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        // Excel格式
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        // 文本格式
        'text/plain',
        'text/csv'
      ];

      // 文件大小限制（10MB）
      const isLt10M = file.size / 1024 / 1024 < 10;

      // 检查文件类型
      const isValidType = allowedTypes.includes(file.type);
      if (!isValidType) {
        this.$message.error('上传文件格式不正确！支持的文件格式：JPG/PNG/PDF/Word/Excel/TXT/CSV');
        return false;
      }

      // 检查文件大小
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
        return false;
      }

      return true;
    },
    // 处理检定证书文件变更
    handleCertFileChange (file, fileList) {
      console.log('检定证书文件变更:', file, fileList);
      this.certFileList = fileList.slice(-1); // 只保留最新的一个文件
      if (file.raw) {
        // 验证文件类型
        const isValidType = ['application/pdf', 'image/jpeg', 'image/png', 'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'text/plain',
          'text/csv'].includes(file.raw.type);
        if (!isValidType) {
          this.$message.error('只能上传PDF/JPG/PNG/DOC/DOCX/XLS/XLSX/TXT/CSV格式的文件!');
          this.certFileList = [];
          return false;
        }

        // 验证文件大小（不超过10MB）
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          this.$message.error('上传文件大小不能超过10MB!');
          this.certFileList = [];
          return false;
        }

        // 获取文件扩展名
        const fileExt = this.getFileExtension(file.raw.name);

        // 创建新的文件名
        const newFileName = `检定证书${fileExt ? '.' + fileExt : ''}`;

        // 创建新的文件对象
        const newFile = new File([file.raw], newFileName, { type: file.raw.type });

        // 更新文件列表
        this.certFileList = [{
          name: newFileName,
          raw: newFile,
          size: file.raw.size,
          type: file.raw.type
        }];

        // 更新上传文件列表
        this.uploadFiles = this.uploadFiles.filter(f => !f.isCertFile);
        this.uploadFiles.push({
          ...file,
          raw: newFile,
          name: newFileName,
          isCertFile: true,
          isNewFile: true
        });
      }
      return true;
    },
    // 移除检定证书文件
    handleCertFileRemove (file) {
      console.log('移除检定证书文件');
      this.certFileList = [];
      // 从上传文件列表中移除
      this.uploadFiles = this.uploadFiles.filter(f => !f.isCertFile);
    },
    // 预览检定证书文件
    handleCertFilePreview (file) {
      if (file.url) {
        window.open(file.url);
      } else if (file.raw) {
        const url = URL.createObjectURL(file.raw);
        window.open(url);
      }
    },
    // 处理证书确认表文件变更
    handleConfirmFileChange (file, fileList) {
      console.log('证书确认表文件变更:', file, fileList);
      this.confirmFileList = fileList.slice(-1); // 只保留最新的一个文件
      if (file.raw) {
        // 验证文件类型
        const isValidType = ['application/pdf', 'image/jpeg', 'image/png', 'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'text/plain',
          'text/csv'].includes(file.raw.type);
        if (!isValidType) {
          this.$message.error('只能上传PDF/JPG/PNG/DOC/DOCX/XLS/XLSX/TXT/CSV格式的文件!');
          this.confirmFileList = [];
          return false;
        }

        // 验证文件大小（不超过10MB）
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          this.$message.error('上传文件大小不能超过10MB!');
          this.confirmFileList = [];
          return false;
        }

        // 获取文件扩展名
        const fileExt = this.getFileExtension(file.raw.name);

        // 创建新的文件名
        const newFileName = `证书确认表${fileExt ? '.' + fileExt : ''}`;

        // 创建新的文件对象
        const newFile = new File([file.raw], newFileName, { type: file.raw.type });

        // 更新文件列表
        this.confirmFileList = [{
          name: newFileName,
          raw: newFile,
          size: file.raw.size,
          type: file.raw.type
        }];

        // 更新上传文件列表
        this.uploadFiles = this.uploadFiles.filter(f => !f.isConfirmFile);
        this.uploadFiles.push({
          ...file,
          raw: newFile,
          name: newFileName,
          isConfirmFile: true,
          isNewFile: true
        });
      }
      return true;
    },
    // 移除证书确认表文件
    handleConfirmFileRemove (file) {
      console.log('移除证书确认表文件');
      this.confirmFileList = [];
      // 从上传文件列表中移除
      this.uploadFiles = this.uploadFiles.filter(f => !f.isConfirmFile);
    },
    // 预览证书确认表文件
    handleConfirmFilePreview (file) {
      if (file.url) {
        window.open(file.url);
      } else if (file.raw) {
        const url = URL.createObjectURL(file.raw);
        window.open(url);
      }
    },
    // 获取文件扩展名
    getFileExtension (filename) {
      if (!filename) return '';
      const parts = filename.split('.');
      return parts.length > 1 ? parts[parts.length - 1] : '';
    },
    // 计算有效期至
    calculateValidity () {
      console.log('计算有效期', this.form.eqptDate, this.form.eqptCycle);
      if (this.form.eqptDate && this.form.eqptCycle > 0) {
        try {
          // 将检定/校准日期转为Date对象
          const startDate = new Date(this.form.eqptDate);
          // 计算有效期，添加校准周期的月数
          const validityDate = new Date(startDate);
          validityDate.setMonth(validityDate.getMonth() + parseInt(this.form.eqptCycle));

          // 修正日期（处理月末问题）
          // 例如：1月31日 + 1个月 应该是 2月28/29日
          if (startDate.getDate() !== validityDate.getDate()) {
            validityDate.setDate(0); // 设置为上个月的最后一天
          }

          // 在计算结果的基础上减去一天
          validityDate.setDate(validityDate.getDate() - 1);

          // 格式化日期为YYYY-MM-DD
          const year = validityDate.getFullYear();
          const month = String(validityDate.getMonth() + 1).padStart(2, '0');
          const day = String(validityDate.getDate()).padStart(2, '0');

          // 更新有效期至字段
          this.form.eqptValidity = `${year}-${month}-${day}`;
          console.log('计算结果', this.form.eqptValidity);
        } catch (error) {
          console.error('计算有效期时出错:', error);
        }
      }
    },
    // 表单提交
    submitForm () {
      this.$refs["form"].validate(valid => {
        if (valid) {
          // 创建FormData对象，用于上传文件
          const formData = new FormData();

          if (this.title === "修改设备校准信息") {
            // 修改模式：将服务器已有文件信息添加到files字段
            const serverFiles = [];

            // 检查检定证书列表中是否有服务器文件
            this.certFileList.forEach(file => {
              if (file.serverFile === true) {
                serverFiles.push(file);
              }
            });

            // 检查证书确认表列表中是否有服务器文件
            this.confirmFileList.forEach(file => {
              if (file.serverFile === true) {
                serverFiles.push(file);
              }
            });

            // 将服务器文件添加到表单中
            this.form.files = serverFiles;
            this.form.oldEqptValidity = this.oldEqptValidity;
            formData.append('dto', JSON.stringify(this.form));

            // 添加新上传的文件
            this.uploadFiles.forEach(file => {
              if (file.isNewFile) {
                formData.append('newFiles', file.raw);
              }
            });

            updateEqptVerification(formData, this.form.id).then(res => {
              if (res.retCode === 'ok') {
                this.$message.success("修改成功");
                this.open = false;
                this.$emit("refresh");
              } else {
                this.$message.error(res.msg || "修改失败");
              }
            });
          } else {
            // 新增模式：将所有文件作为files参数上传
            formData.append('dto', JSON.stringify(this.form));
            this.uploadFiles.forEach(file => {
              if (file.isNewFile) {
                formData.append('files', file.raw);
              }
            });

            saveEqptVerification(formData).then(res => {
              if (res.retCode === 'ok') {
                this.$message.success("新增成功");
                this.open = false;
                this.$emit("refresh");
              } else {
                this.$message.error(res.msg || "新增失败");
              }
            });
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.el-input-number {
  width: 100%;
}
</style>